
    import { defineComponent } from 'vue'
    import Dialog from 'primevue/dialog'
    import schedulerTimingOutputInfoDialogDescriptor from './SchedulerTimingOutputInfoDialogDescriptor.json'
    import TabView from 'primevue/tabview'
    import TabPanel from 'primevue/tabpanel'

    export default defineComponent({
        name: 'scheduler-timing-output-info-dialog',
        components: { Dialog, TabView, TabPanel },
        props: { visible: { type: Boolean }, triggerInfo: { type: Object } },
        emits: ['close'],
        data() {
            return {
                schedulerTimingOutputInfoDialogDescriptor,
                info: null as any
            }
        },
        watch: {
            triggerInfo() {
                this.loadTriggerInfo()
            }
        },
        created() {
            this.loadTriggerInfo()
        },
        methods: {
            loadTriggerInfo() {
                this.info = this.triggerInfo
            },
            closeDialog() {
                this.$emit('close')
            }
        }
    })
